import { css, cx } from 'emotion';
import { grey, lightGrey, headingMedium, mobileMaxWidthBreakpoint } from 'inside-out/global-styles';

export const wrapperLinkStyle = css({
	textDecoration: 'none',
	display: 'table',
	width: '100%',
});

export const metaAudiencesStyle = css({
	marginBottom: '30px',
	'& svg:not(:last-child)': {
		marginRight: '6px',
	},
});

export const metaCategoryStyle = css({
	textTransform: 'uppercase',
	color: grey,
	fontWeight: 'bold',
	fontSize: '12px',
	marginBottom: '14px',
	marginTop: '41px',
	[`@media (max-width: ${mobileMaxWidthBreakpoint}px)`]: {
		marginTop: '24px',
	},
});

export const titleStyle = cx(
	headingMedium,
	css({
		color: '#fff',
		marginBottom: '12px',
		[`@media (max-width: ${mobileMaxWidthBreakpoint}px)`]: {
			fontSize: '16px',
			lineHeight: '19px',
		},
	})
);

export const metaDateStyle = css({
	fontSize: '14px',
	lineHeight: '17px',
	color: '#fff',
	margin: '0',
});

export const wrapperInnerStyle = css({
	position: 'relative',
	zIndex: '1',
});

export const wrapperStyle = background =>
	css({
		display: 'table-cell',
		verticalAlign: 'bottom',
		textDecoration: 'none',
		border: `1px solid ${lightGrey}`,
		borderRadius: '6px',
		width: '100%',
		height: '306px',
		padding: '24px',
		backgroundImage: `url(${background})`,
		backgroundRepeat: 'no-repeat',
		backgroundPosition: 'center center',
		backgroundSize: 'cover',
		boxSizing: 'content-box',
		zIndex: '1',
		position: 'relative',
		'&:after': {
			position: 'absolute',
			top: '0',
			left: '0',
			opacity: '0.6',
			width: '100%',
			height: '100%',
			display: 'block',
			content: '" "',
			background: '#000',
			borderRadius: '6px',
		},
		[`@media (max-width: ${mobileMaxWidthBreakpoint}px)`]: {
			height: '200px',
			padding: '15px',
		},
	});



// WEBPACK FOOTER //
// ./src/components/shared/cards/featuredCard/styles.js